import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { CoverageFilterInput } from '../gql/graphql';
import { toPagination } from './utils';

export const GET_ALAE_PAYMENT_COVERAGES = graphql(`
  query getAlaePaymentCoverages(
    $filters: CoverageFilterInput!
    $pagination: PaginationRequest
  ) {
    alaePaymentCoverages(filters: $filters, pagination: $pagination) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          name
          order
          coverages {
            uuid
            name
            subCoverages {
              edges {
                node {
                  uuid
                  name
                }
              }
            }
          }
          subExpenses {
            uuid
            name
            order
            coverages {
              uuid
              name
              subCoverages {
                edges {
                  node {
                    uuid
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export interface IUseAlaePaymentCoveragesQueryArgs {
  pageNumber?: number;
  pageSize?: number;
  filters: CoverageFilterInput;
  skip?: boolean;
}

export function useAlaePaymentCoveragesQuery({
  pageNumber,
  pageSize,
  filters,
  skip = false,
}: IUseAlaePaymentCoveragesQueryArgs) {
  const { loading, data, error, refetch } = useQuery(
    GET_ALAE_PAYMENT_COVERAGES,
    {
      variables: {
        filters,
        pagination: toPagination(pageNumber, pageSize),
      },
      fetchPolicy: 'no-cache',
      skip,
    }
  );

  return {
    loading,
    error,
    data,
    refetch,
  };
}
